import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      headerContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch',
        flex: 1,
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
          alignItems: 'center',
        },
      },
      headerFooter: {
        paddingTop: theme.spacing(4),
      },
      leftHeader: {
        flex: 1,
        paddingTop: theme.spacing(6),
        paddingRight: theme.spacing(3),
      },
      rightHeader: {
        paddingTop: theme.spacing(2),
        width: '344px',
        [theme.breakpoints.down('sm')]: {
          width: '240px'
        },
      },
      suptitle: {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '162%',
      },
      title: {
        fontFamily: '"Exo 2", sans-serif',
        fontStyle: 'italic',
        fontWeight: 'normal',
        fontSize: '44px',
        lineHeight: '125%',
      },
      subtitle: {
        fontFamily: '"Exo 2", sans-serif',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '24px',
        lineHeight: '162%',
      },
      card: {
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: '8px',
      },
      cardHeaderButton: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing(2),
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
      },
      cardTitle: {
        fontFamily: '"Exo 2", sans-serif',
        fontStyle: 'normal',
        fontWeight: 500,
        fontSize: '18px',
        lineHeight: '162%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        flex: 1,
        padding: theme.spacing(0, 2),
        textAlign: 'left',
        [theme.breakpoints.down('md')]: {
          fontSize: '15px'
        },
        [theme.breakpoints.down('xs')]: {
          minHeight: 'auto !important'
        },
      },
      rightImage: {
        width: '100%',
        height: 'auto',
      },
      collapseIcon: {
        color: sicrediStyle.primarySicredi,
        transform: 'rotate(0deg)',
        transition: 'transform 0.3s ease-out',
      },
      openedCollapseIcon: {
        transform: 'rotate(180deg)',
      },
      collapseContent: {
        padding: theme.spacing(2),
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '162%',
        '& > span': {
          [theme.breakpoints.down('xs')]: {
            minHeight: 'auto !important'
          },
        }
      },
      newsChip: {
        backgroundColor: sicrediStyle.primarySicrediLight,
        color: sicrediStyle.primarySicrediDark,
        position: 'absolute',
        left: theme.spacing(6),
        top: theme.spacing(-2),
      },
      fixedContents: {
        position: 'fixed',
        top: '-9999px',
        left: '-9999px',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch'
      },
      fixedTitles: {
        position: 'fixed',
        top: '-9999px',
        left: '-9999px',
        zIndex: 99999,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'stretch'
      },
      fixedContentItem: {
        flex: 1
      },
    }),
  { name: 'Consulta' }
);
